module.exports = __webpack_public_path__ + "img/fdi_logo.efdc835f.svg";